import React from 'react';
import { Button } from '@material-tailwind/react';

export const Botones = ({sinCambiosPendientes,touched,inicioActualizacionTramite,actualizarTramite,cambiarStatus,finalizar,puedeEditarse}) => {

    return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] z-50 flex justify-center">
                <div className="max-w-7xl w-full px-4">
                    {sinCambiosPendientes() ? (
                        <div className="w-full flex justify-end gap-2">
                            {/* Caso 1: Hay cambios en el formulario -> Botón Grabar */}
                            {Object.entries(touched).filter(item => item[1] === true).length > 0 && (
                            <Button 
                                color="green" 
                                size="md" 
                                onClick={() => inicioActualizacionTramite(actualizarTramite)}
                            >
                                Grabar cambios
                            </Button>
                            )}

                            {/* Caso 2: No hay cambios y es editable -> Botón Cambiar Estado */}
                            {!(Object.entries(touched).length > 0) && puedeEditarse && (
                            <Button color="blue" size="md" onClick={cambiarStatus}>
                                Cambiar el estado del trámite
                            </Button>
                            )}
                        </div>
                    ) : (
                        <div className="bg-red-50 border border-red-200 rounded-lg p-2.5 text-center w-full">
                            <p className="text-xs font-bold text-red-600">Hay archivos pendientes por subir.</p>
                        </div>
                    )}
                </div>
                    <Button 
                        color="black" 
                        size="md" 
                        className="bg-black text-white hover:bg-gray-900 border border-black normal-case font-medium transition-colors"
                        onClick={finalizar}
                    >
                        Cancelar
                    </Button>
                
        </div>
};